/* eslint-disable no-useless-escape */
import {phoneRegexPattern} from 'shared/constants/regexPatterns';

const validatePhoneNumber = (phone) => {
  const regexPhonePattern = phoneRegexPattern;
  return regexPhonePattern.test(phone);
}

export default validatePhoneNumber;